import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {BankStatementsFilter} from './BankStatementsFilter';
import {BankStatementsTable} from './BankStatementsTable';
import {BankStatementsFooter} from './BankStatementsFooter';
import FooterBar from '../../_common/components/FooterBar';
import {useBankStatementsContext} from '../context/BankStatementsContext';

export function BankStatementsCard() {
  const {tableRows} = useBankStatementsContext();

  return (
    // @ts-ignore
    <Card className={'flex-fill bg-transparent shadow-none'} id={'bank-statements-card'}>
      <BankStatementsFilter/>
      {tableRows.length > 0 && <BankStatementsTable/>}
      <FooterBar>
        <BankStatementsFooter/>
      </FooterBar>
    </Card>
  );
}
